<template>
  <div v-if="grouped">
    <div
      class="calendar-day calendar-round"
      :class="{
        past: past,
        future: future,
        active: active
      }"
    >
      <template
        v-for="(item, index) in data"
      >
        <div
          :key="index"
          class="calendar-day calendar-round"
          v-if="(data.length == 4) ? index < 4 : index < 3"
        >
          <div class="calendar-day-tooltip 1">
            <p v-if="item.identification">
              Ref. Prime:
            </p>
            <p v-if="item.identification" class="mb-1">
              <span class="text-bold">
                {{ item.typeOfProcess }}
                {{item.identification}}
              </span>
            </p>

            <p v-if="item.customerReference">
              Ref. Cliente:
            </p>
            <p v-if="item.customerReference" :class="{ 'mb-1': item.category === 'PARCELA_INVOICE' }">
              <span class="text-bold">{{ item.customerReference }}</span>
            </p>

            <p v-if="item.category === 'PARCELA_INVOICE'">
              Total na Moeda:
            </p>
            <p class="mb-1" v-if="item.category === 'PARCELA_INVOICE'">
              <span class="text-bold">
                {{ item.invoiceCurrency }}
                {{ item.invoiceInstallmentValue | fractionFilter }}
              </span>
            </p>

            <p v-if="item.category === 'PARCELA_INVOICE'">
              Total em R$:
            </p>
            <p class="mb-1" v-if="item.category === 'PARCELA_INVOICE'">
              <span class="text-bold">
                {{ item.invoiceInstallmentValueInBrl | moneyFilter }}
              </span>
            </p>

            <p v-if="item.category === 'PARCELA_INVOICE' && item.lastExchangeRate">
              <span class="text-italic text-xs">
                Câmbio atualizado em {{item.lastExchangeUpdate | dateFormat }} com a taxa
                {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 4 }).format(item.lastExchangeRate) }}
              </span>
            </p>
          </div>

          <div
            class="calendar-day-content"
            :class="{
              'numerario': item.category === 'NUMERARIO',
              'numerario-previsto': item.category === 'NUMERARIO_PREVISTO',
              'invoice': item.category === 'PARCELA_INVOICE',
            }"
          >
            <div class="flex1" @click="$emit('innerAction', item)">
              <p class="customer-ref">
                <span v-if="useField == 'identification'">
                  <span class="text-xs">{{ getCalendarType(item) }}</span>
                  <br />
                  {{ item[useField] ?? 'S/I' }}
                </span>
                <span v-else>
                   <span class="text-xs">{{ getCalendarType(item) }}</span>
                  <br />
                  {{ item[useField] ?? 'S/I' }}
                </span>
              </p>
              <p>{{ item.value | moneyFilter }}</p>
            </div>

            <div
              class="relative" style="z-index: 999;"
              v-if="item.category === 'NUMERARIO' && item.documents.length > 0"
            >
              <button
                @click.prevent="$emit('downloadAction', item)"
                type="button"
                class="gs-download"
                :class="{ 'downloaded': item.documents[item.documents.length - 1].logs.length > 0 }"
                title="Baixar numerário"
              >
                <DownloadIcon size="16" />
              </button>
            </div>

            <div
                class="relative tooltip-payment-invoice"
                style="z-index: 999;" v-if="item.category === 'PARCELA_INVOICE'"
            >
                <button @click.prevent="$emit('paymentInvoiceAction', item)" type="button" class="gs-download" title="Alterar status de pagamento">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#104375"><path d="M480-528q-51 0-85.5-34.5t-34.5-85q0-50.5 34.5-85.5t85-35q50.5 0 85.5 35t35 85q0 51-35 85.5T480-528Zm-288 96q-29.7 0-50.85-21.15Q120-474.3 120-504v-288q0-29 21.15-50.5T192-864h576q29 0 50.5 21.5T840-792v288q0 29.7-21.5 50.85Q797-432 768-432H192Zm72-72h432q0-29 21.15-50.5T768-576v-144q-29.7 0-50.85-21.15Q696-762.3 696-792H264q0 30-21.5 51T192-720v144q29 0 50.5 21.5T264-504Zm-72 0v-288 288ZM480-96l144-144-51-51-57 57v-150h-72v150l-57-57-51 51L480-96Z"/></svg>
                </button>
            </div>

            <div v-if="(item.cashRequestDone && item.category === 'NUMERARIO') || (item.invoiceInstallmentIsPaid && item.category === 'PARCELA_INVOICE')" class="ribbon">
              Pago
            </div>
          </div>
        </div>
      </template>

      <div class="calendar-day-footer" v-if="data.length > 4">
        <button @click.prevent="$emit('action', data)">
          <span>VER MAIS ITENS</span>
          <br />
          <span>{{ data.length - 3 }} itens ocultos</span>
        </button>
       </div>
    </div>
  </div>

  <div class="calendar-list-day" v-else>
    <template
      v-for="(item, index) in data"
    >
      <div
        :key="index"
        class="calendar-day calendar-round"
      >
        <div class="calendar-day-tooltip 2">
          <p v-if="item.identification" class="mb-1">
            Ref. Prime: <span class="text-bold">{{ item.identification }}</span>
          </p>
          <p class="mb-1" v-if="item.customerReference">
            Ref. Cliente: <span class="text-bold">{{ item.customerReference }}</span>
          </p>

          <p v-if="item.category === 'PARCELA_INVOICE'">
              Total na Moeda:
            </p>
            <p class="mb-1" v-if="item.category === 'PARCELA_INVOICE'">
              <span class="text-bold">
                {{ item.invoiceCurrency }}
                {{ item.invoiceInstallmentValue | fractionFilter }}
              </span>
            </p>

            <p v-if="item.category === 'PARCELA_INVOICE'">
              Total em R$:
            </p>
            <p class="mb-1" v-if="item.category === 'PARCELA_INVOICE'">
              <span class="text-bold">
                {{ item.invoiceInstallmentValueInBrl | moneyFilter }}
              </span>
            </p>

            <p v-if="item.category === 'PARCELA_INVOICE' && item.lastExchangeRate">
              <span class="text-italic text-xs">
                Câmbio atualizado em {{item.lastExchangeUpdate | dateFormat }} com a taxa
                {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 4 }).format(item.lastExchangeRate) }}
              </span>
            </p>
        </div>

        <div
          class="calendar-day-content"
          :class="{
            'numerario': item.category === 'NUMERARIO',
            'numerario-previsto': item.category === 'NUMERARIO_PREVISTO',
            'invoice': item.category === 'PARCELA_INVOICE',
          }"
        >
          <div class="flex1" @click="$emit('innerAction', item)">
            <p class="customer-ref">
              <span v-if="useField == 'identification'">
                <span class="text-xs">{{ getCalendarType(item) }}</span>
                <br />
                {{ item[useField] ?? 'S/I' }}
              </span>
              <span v-else>
                  <span class="text-xs">{{ getCalendarType(item) }}</span>
                <br />
                {{ item[useField] ?? 'S/I' }}
              </span>
            </p>
            <p>{{ item.value | moneyFilter }}</p>
          </div>

          <div
            class="relative" style="z-index: 999;"
            v-if="item.category === 'NUMERARIO' && item.documents.length > 0"
          >
            <button
              @click.prevent="$emit('downloadAction', item)"
              type="button"
              class="gs-download"
              :class="{
                'downloaded': item.documents[item.documents.length - 1].logs.length > 0
              }"
              data-toggle="tooltip" data-placement="top" title="Baixar numerário"
            >
              <DownloadIcon size="16" />
            </button>
          </div>

          <div class="relative" style="z-index: 999;" v-if="item.category === 'PARCELA_INVOICE'">
            <button @click.prevent="$emit('paymentInvoiceAction', item)" type="button" class="gs-download" title="Alterar status de pagamento">
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#104375"><path d="M480-528q-51 0-85.5-34.5t-34.5-85q0-50.5 34.5-85.5t85-35q50.5 0 85.5 35t35 85q0 51-35 85.5T480-528Zm-288 96q-29.7 0-50.85-21.15Q120-474.3 120-504v-288q0-29 21.15-50.5T192-864h576q29 0 50.5 21.5T840-792v288q0 29.7-21.5 50.85Q797-432 768-432H192Zm72-72h432q0-29 21.15-50.5T768-576v-144q-29.7 0-50.85-21.15Q696-762.3 696-792H264q0 30-21.5 51T192-720v144q29 0 50.5 21.5T264-504Zm-72 0v-288 288ZM480-96l144-144-51-51-57 57v-150h-72v150l-57-57-51 51L480-96Z"/></svg>
            </button>

          </div>

          <div v-if="(item.cashRequestDone && item.category === 'NUMERARIO') || (item.invoiceInstallmentIsPaid && item.category === 'PARCELA_INVOICE')" class="ribbon">
            Pago
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { DownloadIcon } from '@/components/Icons';
import moment from 'moment';

export default {
  name: 'GsCalendarDayContent',
  components: { DownloadIcon },
  props: {
    date: {
      type: Date,
    },
    data: {
      type: Array,
      default: () => [],
    },
    past: {
      type: Boolean,
      default: false,
    },
    future: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    grouped: {
      type: Boolean,
      default: true,
    },
    useField: {
      type: String,
      default: 'invoice',
    },
  },
  filters: {
    moneyFilter(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    },
    fractionFilter(value) {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    typeOfProcess(value) {
      switch (value) {
        case 'CONTA_E_ORDEM':
          return 'PRI';

        case 'ENCOMENDA':
          return 'E';

        case 'ASSESSORIA':
          return 'A';

        default:
          return 'PRI';
      }
    },
    dateFormat(value) {
      return moment(value).format('DD/MM/YYYY');
    },
  },
  methods: {
    getCalendarType(item) {
      const types = {
        NUMERARIO: 'Numerário',
        NUMERARIO_PREVISTO: 'Numerário Previsto',
        PARCELA_INVOICE: 'Invoice',
      };

      return types[item.category];
    },
    getInvoiceCurrency(item, invoiceId) {
      return item.invoices.find((inv) => inv.id === invoiceId).currency;
    },
  },
};
</script>

<style scoped>

.tooltip-invoice-text {
    left: calc(100% + 10px);
    opacity: 1;
    visibility: visible;
    position: absolute;
    top: 50%;
    transform: translate3d(0, -50%, 0);
    background-color: white;
    z-index: 99;
    pointer-events: none;
    padding: 0.75rem;
    border-radius: var(--medium-border-radius);
    color: var(--primary-color);
    box-shadow: var(--box-shadow);
    border: 1px solid var(--primary-color);
    transition: var(--all-transition);
}

.tooltip-invoice-text::after,
.tooltip-invoice-text::before {
  content: '';
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  border-style: solid;
  border-width: 5px 10px 5px 0;
  border-color: transparent white transparent transparent;
  top: 50%;
  left: -10px;
  transform: translateY(-50%);
}

.tooltip-invoice-text::before {
  border-width: 6px 11px 6px 0;
  left: -11px;
  border-color: transparent var(--primary-color) transparent transparent;
}
.calendar-day {
  cursor: pointer;
  /* overflow: hidden; */
  margin-bottom: 0.25rem;
  position: relative;
}

.calendar-day-tooltip {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: calc(100% + 5px);
  font-size: 0.8rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
  padding: 0.5rem;
  z-index: 999999;
  pointer-events: none;

  transition: all .1s ease-in-out 0s;

  opacity: 0;
  visibility: hidden;
  transform: translate3d(0, 15px, 0);
}

.calendar-day:hover > .calendar-day-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translate3d(0, 0, 0);
}

.calendar-day-content {
  padding: 3px 0.5rem;
  font-size: 0.8rem;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-width: 1.5px;
  border-style: solid;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
}

.calendar-day-content p:last-of-type {
  font-weight: bold;
}

.calendar-day-content,
.calendar-day-content p {
  transition: all .2s ease-in-out 0s;
}

/* Numerário Previsto */

.calendar-day-content.numerario-previsto {
  background-color: white;
  border-color: #147702;
}

.calendar-day-content.numerario-previsto p {
  color: #147702;
}

.calendar-day-content.numerario-previsto:hover {
  background-color: #147702;
}

.calendar-day-content.numerario-previsto:hover p {
  color: white;
}

/* Numerário Previsto */

/* Numerário */

.calendar-day-content.numerario {
  background-color: #147702;
  border-color: #147702;
}

.calendar-day-content.numerario p {
  color: white;
}

.calendar-day-content.numerario:hover {
  background-color: white;
}

.calendar-day-content.numerario:hover p {
  color: #147702;
}

/* Numerário */

/* Invoice */

.calendar-day-content.invoice {
  background-color: #09233c;
  border-color: #09233c;
}

.calendar-day-content.invoice p {
  color: white;
}

.calendar-day-content.invoice:hover {
  background-color: white;
}

.calendar-day-content.invoice:hover p {
  color: #09233c;
}

.calendar-day-content .ribbon {
  position: absolute;
  top: 1px;
  left: -17px;
  transform: rotate(-45deg);
  background-color: red;
  color: white;
  padding: 0.25rem 1rem;
  font-size: 0.6rem;
}
/* Invoice */

.calendar-list-day .calendar-day {
  cursor: pointer;
}

.calendar-day-header {
  padding: 0.5rem;
  color: white;
  font-weight: 600;
  text-align: center;
  background-color: var(--primary-color);
  text-transform: uppercase;
}

.calendar-list-day .calendar-day-header {
  margin-bottom: 0;
}

.calendar-day-header.past {
  background-color: #2b6a17;
}

.calendar-day-header.future {
  background-color: var(--primary-color);
}

.calendar-day-header.active {
  background-color: #e2665e;
}

.calendar-day-footer {
  /* padding: 0.75rem; */
  font-size: 0.9rem;
}

.calendar-day-footer {
  padding-top: 0;
}

.calendar-day-footer button {
  font-family: var(--body-font-family);
  width: 100%;
  display: block;
  text-align: center;
  border-radius: 10px;
  font-weight: 900;
  border: 0;
  background-color: transparent;
  color: var(--primary-color);
  cursor: pointer;
  transition: all .2s ease-in-out 0s;
  margin-top: 0.5rem;
}

.calendar-day-footer button span:last-of-type {
  font-weight: 300;
}

.calendar-list-day {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.customer-ref {
  word-break: break-all;
}

.gs-download {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--accent-color);
  color: white;
}

.gs-download.downloaded {
  background-color: #e2e2e2;
  color: black;
}

.button-tooltip {
  transition: all .2s ease-in-out 0s;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  z-index: 9;
  bottom: 50%;
  transform: translate3d(0, 50%, 0);
  right: calc(100% + 10px);
  background-color: white;
  color: black;
  font-size: 0.8rem;
  border-radius: 5px;
  padding: 0.5rem;
  border: 1px solid black;
}

.gs-download:hover ~ .button-tooltip {
  opacity: 1;
  visibility: visible;
}

.calendar-list-day .calendar-day:first-child .calendar-day-tooltip,
.calendar-list-day .calendar-day:nth-child(2) .calendar-day-tooltip,
.calendar-list-day .calendar-day:nth-child(3) .calendar-day-tooltip {
  top: calc(100% + 5px);
  bottom: unset;
}
</style>
